import { render, staticRenderFns } from "./dual-list.vue?vue&type=template&id=1cc0e6d4&scoped=true"
import script from "./dual-list.vue?vue&type=script&lang=js"
export * from "./dual-list.vue?vue&type=script&lang=js"
import style0 from "./dual-list.vue?vue&type=style&index=0&id=1cc0e6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc0e6d4",
  null
  
)

export default component.exports